import { render, staticRenderFns } from "./CloHeaderGroup.vue?vue&type=template&id=04ff1fdf&"
import script from "./CloHeaderGroup.vue?vue&type=script&lang=js&"
export * from "./CloHeaderGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports